export default __webpack_public_path__ + "static/device-FooterBanner-57b68dc842a7bf761c575725d52ed731.png";